import { render, staticRenderFns } from "./brandGroup.vue?vue&type=template&id=77036116"
import script from "./brandGroup.vue?vue&type=script&lang=js"
export * from "./brandGroup.vue?vue&type=script&lang=js"
import style0 from "./brandGroup.vue?vue&type=style&index=0&id=77036116&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports